import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

// ** Import custom components for redux **
import { AuthContextProvider } from './context/authContext/AuthContext';

// Import custom Components
import App from './components/app';

import Default from './components/dashboard/default';
import UOMManage from './components/dashboard/UOMManage';
import UOMConversionManage from './components/dashboard/UOMConversionManage';
import SKUTypeManage from './components/dashboard/SKUTypeManage';
import SchoolCalendarManage from './components/dashboard/SchoolCalendarManage';
import ProjectManage from './components/dashboard/ProjectManage';
import FieldWorkerManage from './components/dashboard/FieldWorkerManage';
import SchoolManage from './components/dashboard/SchoolManage';
import MenuManage from './components/dashboard/MenuManage';
import MenuDetailManage from './components/dashboard/MenuDetailManage';
import SKUManage from './components/dashboard/SKUManage';
import SchoolCalendarTerms from './components/dashboard/SchoolCalendarTermsManage';
import PublicHolidayManage from './components/dashboard/PublicHolidayManage';
import DeliveryRunManage from './components/dashboard/DeliveryRunManage';
import DeliveryRunTypeManage from './components/dashboard/DeliveryRunTypeManage';
import EmailManage from './components/dashboard/EmailManage';
import ExceptionManage from './components/dashboard/ExceptionManage';
import ActionLogManage from './components/dashboard/ActionLogManage';

import EmailView from './components/views/EmailView';
import DeliveryRunSummary from './components/views/DeliveryRunSummary';
import DeliveryRunDetails from './components/views/DeliveryRunDetails';

import Footer from './components/common/footer';

import UserManage from './components/dashboard/userManage';
import UserCreate from './components/forms/form-layout/userCreate';
import UserUpdate from './components/forms/form-layout/userUpdate';
import SkuCreate from './components/forms/form-layout/skuCreate';
import DeliveryRunCreate from './components/forms/form-layout/deliveryRunCreate';
import ExceptionCreate from './components/forms/form-layout/exceptionCreate';

// pages
import Signin from './pages/signin';
import UnlockUser from './pages/unlockUser';
import ForgetPwd from './pages/forgetPwd';
import ResetPwd from './pages/resetPwd';
// import ComingSoon from './pages/maintenance';
import { ToastContainer } from 'react-toastify';
// import Error404 from './pages/error404';

// Auth
import { useContext } from 'react';
import { AuthContext } from './context/authContext/AuthContext';

// Theme
import { ThemeProvider } from '@mui/material';
import theme from './ThemeProvider';
import StockSummary from './components/views/StockSummary';

const Root = () => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const abortController = new AbortController();
    console.ignoredYellowBox = ['Warning: Each', 'Warning: Failed'];
    console.disableYellowBox = true;

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  return (
    <div className="App">
      <AuthContextProvider>
        <ThemeProvider theme={theme}>
          <BrowserRouter basename={`/`}>
            <Switch>
              {/* pages */}
              {/* <div> */}
              <Route exact path={`${process.env.PUBLIC_URL}/login`}>
                {!user ? <Signin /> : <Redirect to={`${process.env.PUBLIC_URL}`} />}
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/confirm-email/:token`} component={UnlockUser} />
              <Route exact path={`${process.env.PUBLIC_URL}/reset-password`} component={ForgetPwd} />
              <Route exact path={`${process.env.PUBLIC_URL}/reset-password/:token`} component={ResetPwd} />
              {/* </div> */}

              {user ? (
                <App>
                  {/* dashboard menu */}
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/`}
                    render={() => {
                      return <Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />;
                    }}
                  />
                  <Route exact path={`${process.env.PUBLIC_URL}/dashboard`} component={Default} />

                  <Route exact path={`${process.env.PUBLIC_URL}/users/manage`} component={UserManage} />
                  <Route exact path={`${process.env.PUBLIC_URL}/users/create`} component={UserCreate} />
                  <Route exact path={`${process.env.PUBLIC_URL}/users/edit/:id`} component={UserUpdate} />
                  <Route exact path={`${process.env.PUBLIC_URL}/skus/create`} component={SkuCreate} />
                  <Route exact path={`${process.env.PUBLIC_URL}/skus/edit/:id`} component={SkuCreate} />
                  <Route exact path={`${process.env.PUBLIC_URL}/delivery-runs/create`} component={DeliveryRunCreate} />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/delivery-runs/edit/:id`}
                    component={DeliveryRunCreate}
                  />
                  <Route exact path={`${process.env.PUBLIC_URL}/exceptions/create`} component={ExceptionCreate} />
                  <Route exact path={`${process.env.PUBLIC_URL}/exceptions/edit/:id`} component={ExceptionCreate} />

                  <Route exact path={`${process.env.PUBLIC_URL}/uom/manage`} component={UOMManage} />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/uom-conversions/manage`}
                    component={UOMConversionManage}
                  />
                  <Route exact path={`${process.env.PUBLIC_URL}/sku-types/manage`} component={SKUTypeManage} />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/school-calendars/manage`}
                    component={SchoolCalendarManage}
                  />
                  <Route exact path={`${process.env.PUBLIC_URL}/projects/manage`} component={ProjectManage} />
                  <Route exact path={`${process.env.PUBLIC_URL}/field-workers/manage`} component={FieldWorkerManage} />
                  <Route exact path={`${process.env.PUBLIC_URL}/schools/manage`} component={SchoolManage} />
                  <Route exact path={`${process.env.PUBLIC_URL}/menus/manage`} component={MenuManage} />
                  <Route exact path={`${process.env.PUBLIC_URL}/menu-details/manage`} component={MenuDetailManage} />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/school-calendar-terms/manage`}
                    component={SchoolCalendarTerms}
                  />
                  <Route exact path={`${process.env.PUBLIC_URL}/skus/manage`} component={SKUManage} />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/public-holidays/manage`}
                    component={PublicHolidayManage}
                  />
                  <Route exact path={`${process.env.PUBLIC_URL}/delivery-runs/manage`} component={DeliveryRunManage} />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/delivery-run-types/manage`}
                    component={DeliveryRunTypeManage}
                  />
                  <Route exact path={`${process.env.PUBLIC_URL}/emails/manage`} component={EmailManage} />
                  <Route exact path={`${process.env.PUBLIC_URL}/exceptions/manage`} component={ExceptionManage} />
                  <Route exact path={`${process.env.PUBLIC_URL}/action-logs/manage`} component={ActionLogManage} />

                  <Route exact path={`${process.env.PUBLIC_URL}/emails/view/:id`} component={EmailView} />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/reports/delivery-run-summary`}
                    component={DeliveryRunSummary}
                  />
                  <Route exact path={`${process.env.PUBLIC_URL}/reports/stock-summary`} component={StockSummary} />
                  <Route
                    exact
                    path={`${process.env.PUBLIC_URL}/reports/delivery-run-details/:id`}
                    component={DeliveryRunDetails}
                  />

                  {/* <Route component={Error404} /> */}
                </App>
              ) : (
                <Redirect to={`${process.env.PUBLIC_URL}/login`} />
              )}
            </Switch>
          </BrowserRouter>
          {!user && <Footer />}
        </ThemeProvider>
      </AuthContextProvider>
      <ToastContainer theme="colored" />
    </div>
  );
};

ReactDOM.render(<Root />, document.getElementById('root'));
